import React, { useEffect, useState } from "react";
import { Button, Badge, Col, Form, Modal, Row } from "react-bootstrap";

function ReleaseNotesModal(props) {
  const [messageText, setMessageText] = useState("");

  const handleClearAndClose = () => {
    setMessageText("");
    props.onHide();
  };

  const handleSubmitData = () => {
    props.submitNotes(messageText);
    handleClearAndClose();
  };

  return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Form id={"sendMessageForm"}>
        <Modal.Header id="modalHeader">
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body id="modalBody">
          <div style={{ fontSize: '20px', textAlign: "left", color: "green" }}>
            <p>{props.subTitle}</p>
          </div>
          <Form.Group controlId="formLink">
            <Row>
              <Col style={{ flex: 1.6 }}>
                <Form.Label>Note</Form.Label>
                <Form.Control
                  style={{ border: "1px solid lightgray", background: "rgba(0,0,0,0.05)" }}
                  as="textarea"
                  rows={10}
                  value={messageText}
                  onChange={e => setMessageText(e.target.value)}
                />
              </Col>
              <Col style={{ flex: 0.4 }}>
                <b>Patient Demographic Details</b>
                <div style={{ textAlign: "left" }}>
                  Name : &nbsp; {props.details?.firstName} {props.details?.lastName}
                </div>
                <div style={{ textAlign: "left" }}>Email : &nbsp; {props.details?.email}</div>
                <div style={{ textAlign: "left" }}>Phone : &nbsp; {props.details?.phone}</div>
                <div style={{ textAlign: "left" }}>State : &nbsp; {props.details?.state}</div>
                <div style={{ textAlign: "left" }}>DOB : &nbsp; {props.details?.dob}</div>
                <div style={{ textAlign: "left" }}>Sex Assigned : &nbsp; {props.details?.genderAtBirth}</div>
              </Col>
            </Row>
            <hr></hr>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" type="button" onClick={handleClearAndClose}>
            Cancel
          </Button>
          {/* <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitSaveDraft()}>
                Save Draft
              </Button> */}
          <Button id="msg_reply" class="" onClick={handleSubmitData}>
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ReleaseNotesModal;
